import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import basketSelector from 'selectors/basket/basketSelector';
import BeautyInsiderSelector from 'selectors/beautyInsider/beautyInsiderSelector';
import userUtils from 'utils/User';
import localeUtils from 'utils/LanguageLocale';
import BeautyInsiderMissedRewardsEN from 'components/Content/BeautyInsider/BeautyInsiderMissedRewards/locales/BeautyInsiderMissedRewards_en_US';
import BeautyInsiderMissedRewardsFR from 'components/Content/BeautyInsider/BeautyInsiderMissedRewards/locales/BeautyInsiderMissedRewards_fr_CA';
import Empty from 'constants/empty';

const { wrapHOC } = FrameworkUtils;
const { beautyInsiderSelector } = BeautyInsiderSelector;

const getText = localeUtils.getLocalisedDataFromResource(BeautyInsiderMissedRewardsEN, BeautyInsiderMissedRewardsFR);

const fields = createSelector(userSelector, basketSelector, beautyInsiderSelector, (user, basket, beautyInsider) => {
    return {
        missedRewards: (beautyInsider.biRewardGroups || {})['YouJustMissedIt'] || Empty.Array,
        isAnonymous: user.isInitialized && userUtils.isAnonymous(),
        basket,
        localization: {
            youJustMissedThese: getText('youJustMissedThese'),
            rougeBadge: getText('rougeBadge')
        }
    };
});

const functions = () => ({});

const withBeautyInsiderMissedRewardsProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderMissedRewardsProps, fields, functions
};
